<div class="app-container">
  <a class="skip-link" href="#main-content">Skip to main content</a>

  <app-header></app-header>
  <app-toasts></app-toasts>

  <div class="position-fixed top-0 end-0 p-3 toast-container" style="z-index:1055">
    <div *ngIf="successMsg" class="alert alert-success alert-dismissible fade show" role="status" aria-live="polite">
      {{ successMsg }}
      <button type="button" class="btn-close" aria-label="Close" (click)="successMsg = ''"></button>
    </div>
  </div>

  <main id="main-content" class="app-main" tabindex="-1">
    <router-outlet></router-outlet>
  </main>

  <footer class="app-footer text-white py-4 mt-5">
    <div class="container d-flex flex-column flex-md-row align-items-center justify-content-between">
      <p class="mb-2 mb-md-0">&copy; 2026 Upcoming Cars. All rights reserved.</p>
      <span class="footer-status">Premium upcoming car discovery</span>
    </div>
  </footer>
</div>
